import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.actions';

export default defineMessages({
  listItemActionMove: {
    id: `${scope}.list.item.action.move`,
    defaultMessage: 'Move',
  },
  listItemActionDelete: {
    id: `${scope}.list.item.action.delete`,
    defaultMessage: 'Delete',
  },
});
